import { render, staticRenderFns } from "./UiPagination.vue?vue&type=template&id=0a0d99e7&"
import script from "./UiPagination.vue?vue&type=script&lang=js&"
export * from "./UiPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports